export const COLORS: any = {
	WATER_BLUE: '#1291d9',
	PUMPKIN: '#ef7d00',
	WHITE: '#ffffff',
	VERY_LIGHT_PINK: '#e4e4e4',
	LIGHT_BLUE_GREY: '#ced4da',
	GREY: '#9599a0',
	DOWN: '#9599a0',
	SLATE_GREY: '#525a67',
	CHARCOAL_GREY: '#313840',
	BROWNISH_GREY: '#707070',
	GREEN: '#04ba6f',
	LIGHT_GREY: '#efefef',

	VERY_LIGHT_GREEN: '#f0faf4',
	LIGHT_GREEN: '#e6f7ed',
	PALE_GREEN: '#d4f5e0',
	VERY_LIGHT_PUMPKIN: '#fff8f0',
	LIGHT_PUMPKIN: '#ffe8cc',
	VERY_LIGHT_RED: '#fff0f0',
	LIGHT_RED: '#ffe0e0',
	RED: '#d64545',
};

export const FONTS: any = {
	NanumSquare_Bold: 'asdsa',
};
